<template>
  <div class="manage-container">
    <el-card shadow="never">
      <i class="el-icon-tickets"></i>
      <span>角色授权</span>
      <el-button class="btn-refresh el-icon-refresh">刷新</el-button>
    </el-card>
    <div>
      <el-card class="box-card" shadow="never">
        <i class="el-icon-s-fold"></i>
        <span>角色列表</span>
        <el-button
          type="primary"
          @click="addNewRow()"
          style="float:right; margin:3px 0;"
        >添加</el-button>
      </el-card>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column type="selection" width="120" align="center"></el-table-column>
      <el-table-column prop="number" label="编号" width="300" align="center"></el-table-column>
      <el-table-column prop="role" label="角色名称" width="500" align="center"></el-table-column>
      <el-table-column label="操作" width="500" align="center">
        <template slot-scope="scope">
          <el-button @click="dialogVisible = true" type="text" size="small">编辑</el-button>
          <el-button type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="role-bottom">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="40"
      ></el-pagination>
    </div>
    <!-- 新建角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <el-form :model="addNewRow" ref="numberValidateForm" label-width="100px">
        <el-form-item
          label="角色"
          prop="role"
          :rules="[
      { required: true, message: '角色不能为空'}
    ]"
        >
          <el-input v-model.number="numberValidateForm.role"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="dialogVisible = false">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "role",
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '',
      currentPage4: 4,
      checked: false,
      formInline: {
        user: "",
        region: ""
      },
      tableData: [
        {
          number: "1",
          role: "超级管理员"
        },
        {
          number: "2",
          role: "总经理"
        }
      ],
      numberValidateForm: {
        role: ""
      }
    };
  },
  methods: {
    addNewRow() {
        this.dialogVisible = true;
        this.dialogTitle = "角色名称";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang='less' scoped>
.btn-refresh {
  float: right;
  padding: 10px 20px;
}
.role-bottom {
  margin: 30px 15px;
}
.el-pagination {
  text-align: center;
}
</style>
